module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindentfirst"
  }, [_c('a', {
    attrs: {
      "href": "#/001cover"
    }
  }, [_vm._v("Cover Page")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/002titlepage"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/004dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/005epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "parti"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006part1"
    }
  }, [_vm._v("PART I: HOW TO HAVE AN ORIGIN WITHOUT A PLANET BLOWING UP, PARENTS MURDERED, RADIOACTIVE SPIDER BITES, COSMIC RAYS, GAMMA RAYS, WHITE DWARF STARS, ALIENS CRASH-LANDING, A MAGIC WORD, A MAGIC HAMMER, OR A SUPER SERUM")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterone"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptertwo"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterthree"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterfour"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/010chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterfive"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptersix"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterseven"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptereight"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapternine"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "partii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: “YOU STILL READ COMIC BOOKS AT YOUR AGE?!”")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterten"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptereleven"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/018chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptertwelve"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterthirteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "partiii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/021part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: BLOOMINGTON TO HOLLYWOOD: HOW TO GET THERE FROM HERE!")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterfourteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/022chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterfifteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptersixteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/024chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapterseventeen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/025chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "partiv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/026part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: AT LONG LAST, THE DARK KNIGHT RETURNS!")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptereighteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/027chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chapternineteen"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/028chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptertwenty"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/029chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptertwenty-one"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/030chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "partv"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/031part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V: “BATS” OF LUCK")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "chaptertwenty-two"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/032chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "epilogue2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/033epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE The Road Taken, the Road Not Taken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/034acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "imagecredits"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/035imagecredits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMAGE CREDITS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/036poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poem")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/037copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896f91b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003toc.vue
// module id = 63
// module chunks = 0